export default function getInitialState() {
  return {
    isBeRightBackOn: false,
    beRightBackStatuses: {}
  };
}
